<lib-panel-layout>
  <div class="flex flex-col items-stretch w-full min-w-0 gap-3 xl:items-center">
    <div class="grid grid-cols-2 gap-2.5 w-full">
      @for (mode of cropModes; track mode) {
        <button
          libButton
          variant="primary"
          size="xs"
          type="button"
          class="w-full gap-1.5 px-3! text-xs"
          [class.is-pressed]="mode.isSelected"
          (click)="onModeSelected(mode)">
          <span class="noselect truncate">{{ mode.Name | translate }}</span>
          @if (showsCropIcon(mode)) {
            <mat-icon svgIcon="crop" class="size-4! shrink-0"></mat-icon>
          }
        </button>
      }
    </div>
  </div>

  <lib-apply-panel panelActions class="w-full" (apply)="onApply()" (cancelRequested)="onCancel()"> </lib-apply-panel>
</lib-panel-layout>
